import { AutoCompleteMulti, ISelectType, useFetch } from "@4uhub/lib4uhub";
import { Grid } from "@mui/material";
import { memo, useCallback, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { sectorEmr } from "../../../../../../../services/sectorEmr.service";
import { useAutomationRules } from "../../../../../../../store/contexts/AutomationRulesContext";

const translationPath = "components.messages.";
const SURGERY_AUTOMATION_CODE = "35";

export const SurgeryServiceSectorField = memo(() => {
  const { t } = useTranslation();
  const [options, setOptions] = useState<ISelectType[]>([]);
  const { sendRequest } = useFetch(sectorEmr);
  const { automation } = useAutomationRules();

  const fetchOptions = useCallback(async () => {
    if (String(automation?.code) !== SURGERY_AUTOMATION_CODE) return;

    const { data, success } = await sendRequest({ Enable: true });
    if (data && success) {
      setOptions(
        data.map((item) => ({
          id: String(item.identifier),
          name: item.name,
        })),
      );
    }
  }, [automation?.code, sendRequest]);

  useEffect(() => {
    fetchOptions();
  }, [fetchOptions]);

  if (String(automation?.code) !== SURGERY_AUTOMATION_CODE) return null;

  return (
    <Grid item xs={12} sm={12}>
      <AutoCompleteMulti
        fullWidth
        options={options}
        name="surgeryServiceSectors"
        label={t(translationPath + "surgeryServiceSectors")}
        getOptionLabel={(option) => option.name}
        size="small"
      />
    </Grid>
  );
});
